(function() {
  'use strict';

  angular
    .module('admin.channel_group.children.service', [])
    .factory('ChannelGroupChildrenService', ChannelGroupChildrenService);

  /** @ngInject */
  function ChannelGroupChildrenService($http, $q, API) {

    function list(parentId, start, limit, sort){
        var defered = $q.defer();

        $http.get(API.API_URL + 'admin/channel_groups/' + parentId +'/cgcs?start=' + start + '&limit=' + limit + '&sort=' + sort)
          .success(defered.resolve);

        return defered.promise;
    }

    function listChannel(){
        var defered = $q.defer();

        $http.get(API.API_URL + 'admin/channels')
          .success(defered.resolve);

        return defered.promise;
    }

    function get(parentId, id){
        var defered = $q.defer();

        $http.get(API.API_URL + 'admin/channel_groups/' + parentId + '/cgcs/' + id)
          .success(defered.resolve);

        return defered.promise;
    }

    function save(parentId, model){
        var defered = $q.defer();

        $http.post(API.API_URL + 'admin/channel_groups/' + parentId + '/cgcs', model)
          .success(defered.resolve)
          .error(function(result){
            swal(result.error.message, "", "error");
          });

        return defered.promise;
    }

    function update(parentId,id, model){
        var defered = $q.defer();

        $http.put(API.API_URL + 'admin/channel_groups/' + parentId + '/cgcs/' + id, model)
          .success(defered.resolve)
          .error(function(result){
            swal(result.error.message, "", "error");
          });

        return defered.promise;
    }

    function remove(parentId, id){
        var defered = $q.defer();

        $http.delete(API.API_URL + 'admin/channel_groups/' + parentId + '/cgcs/' + id)
          .success(defered.resolve)
          .error(function(result){
            swal(result.error.message, "", "error");
          });

        return defered.promise;
    }

    return{
        list: list,
        listChannel: listChannel,
        get: get,
        save: save,
        update: update,
        remove: remove
    };

  }

})();
